var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"size":_vm.size,"type":"text"},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.getName()))])}
var staticRenderFns = []

export { render, staticRenderFns }